import React, { useRef } from 'react';
import styles from './TextOverflowTooltip.module.scss';
import { SFTooltip, SFTooltipProps } from 'sfui';
import { InteractiveBox } from 'ui-smartforce-settings';
import { isMobile } from '../../Helpers';

export interface TextOverflowTooltipProps extends SFTooltipProps {}

const isTextOverflown = (element: HTMLElement) => {
  return element.scrollWidth > element.clientWidth;
};

export const TextOverflowTooltip = ({
  children,
  title,
  ...props
}: TextOverflowTooltipProps): React.ReactElement<TextOverflowTooltipProps> => {
  const [isTooltipOpen, setIsTooltipOpen] = React.useState<boolean>(false);
  const [isOverflow, setIsOverflow] = React.useState<boolean>(false);
  const refItem = useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const container = refItem.current;

    if (container) {
      const resizeObserver = new ResizeObserver(() =>
        setIsOverflow(isTextOverflown(container))
      );

      resizeObserver.observe(container);

      return () => {
        resizeObserver.unobserve(container);
      };
    }
  }, []);

  const onClick = () => {
    if (isMobile() && isOverflow && !isTooltipOpen) {
      setIsTooltipOpen(true);
    }
  };

  const onTooltipClose = () => {
    if (isMobile()) {
      setIsTooltipOpen(false);
    }
  };

  return (
    <SFTooltip
      {...props}
      title={title}
      open={isMobile() ? isTooltipOpen : undefined}
      onClose={onTooltipClose}
      disableHoverListener={isMobile() || !isOverflow}
      disableTouchListener={!isOverflow}
      PopperProps={{ disablePortal: true, style: { zIndex: 1199 } }}
    >
      <InteractiveBox className={styles.text} ref={refItem} onClick={onClick}>
        {children}
      </InteractiveBox>
    </SFTooltip>
  );
};
